import Grid from '@mui/material/Grid';
import intl from 'react-intl-universal';
import PaperWidget from '../components/dashboard/PaperWidget';
import CustomerService from '../services/CustomerService';
import { useLoaderData } from "react-router-dom";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import { Box } from '@mui/system';
import NotesIcon from '@mui/icons-material/Notes';

export const ScheduleLoader = (auth) =>
	async () => {
		if(!auth || !auth.isAuthenticated() ){
			return null;
		}
		
		const [purchasedServiceResponse] = await Promise.all(
			    [
					CustomerService.getPurchasedServices(auth, auth.data.current.user.customerId)
				]);
		return {purchasedServiceResponse };
	}


function ScheduleDetails() {

	const { purchasedServiceResponse } = useLoaderData();
	const purchasedServices = purchasedServiceResponse.items || [];
	console.debug( "purchasedServices", purchasedServices);

	return (
		<TableContainer>
			<Table  className="styled-table">
		        <TableHead>
		          <TableRow>
		            <TableCell>{intl.get('service').d('Service')}</TableCell>
		            <TableCell>{intl.get('scheduledDate').d('Scheduled Date')}</TableCell>
		            <TableCell>{intl.get('scheduledTime').d('Scheduled Time')}</TableCell>
		            <TableCell>{intl.get('instructorName').d('Instructor Name')}</TableCell>
		            <TableCell>
					    <Box display="flex" alignItems="center">
					      <span>{intl.get('notes').d('Notes')}</span>
					      <NotesIcon fontSize='small' />				      
					    </Box>	             
		            </TableCell>
		            <TableCell>{intl.get('status').d('Status')}</TableCell>
		            <TableCell>{intl.get('roadTestLocation').d('Road test location')}</TableCell>
		          </TableRow>
		        </TableHead>
		        <TableBody>
		          {purchasedServices.map((row) => (
		            <TableRow key={row.purchasedServiceId}>
		              <TableCell>{row.serviceName}</TableCell>
		              <TableCell>{row.scheduledDate}</TableCell>
		              <TableCell>{row.scheduledTime}</TableCell>
		              <TableCell>{row.instructorName}</TableCell>
		             
		              <TableCell className="ellipsis">
	               	  	<Tooltip title={row.note}>
	               	  	 	<span>{row.note}</span>
	              			
	              	  	</Tooltip>
		              </TableCell>
		 
		              <TableCell>{row.status.statusName}</TableCell>
		              <TableCell>{row.locationName}</TableCell>
		            </TableRow>
		          ))}
		        </TableBody>
		      </Table>
	      </TableContainer>
    ); 	
}


export default function Schedule() {
	return (
		<>
			<Grid container spacing={3}>
				<PaperWidget
					title="Schedule"
					gridProps={{ xs: 12, md: 4, lg: 9 }}
					paperProps={{ sx: { p: 2, display: 'flex', flexDirection: 'column' } }}
				>
					<ScheduleDetails />
				</PaperWidget>
			</Grid>
		</>
		
	);
}